const colors = {
  lightGrey: "#eee",
  grey: "#d1d1d1",
  darkGrey: "rgb(70,70,70)",
};

export default colors;
